import {
  nextArrow, prevArrow
} from "@/global/slick-options";

jQuery( '.topImage' ).slick( {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  autoplay: false,
  rows: 0,
  asNavFor: '.topImageNav'
} );

jQuery( '.topImageNav' ).slick( {
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.topImage',
  autoplay: false,
  dots: false,
  fade: false,
  arrows: true,
  centerMode: true,
  rows: 0,
  centerPadding: '0',
  prevArrow,
  nextArrow
} );